module.exports = __webpack_public_path__ + "img/xiangji.36b9beb5.png";